<main class="main-wrap">
  <div class="left-sidebar-wrapper">
    <span class="goback" (click)="goBack($event)">
      <a class="btn btn-grey-bg">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.224124 8.5555C-0.0747085 8.2456 -0.0747085 7.75479 0.224124 7.44489L6.39555 1.04488C6.70224 0.726837 7.20869 0.717629 7.52674 1.02432C7.84478 1.33101 7.85399 1.83746 7.5473 2.1555L2.68278 7.20019L15.2 7.20019C15.6418 7.20019 16 7.55837 16 8.00019C16 8.44202 15.6418 8.80019 15.2 8.80019L2.68278 8.80019L7.5473 13.8449C7.85399 14.1629 7.84478 14.6694 7.52674 14.9761C7.20869 15.2828 6.70224 15.2735 6.39555 14.9555L0.224124 8.5555Z"
            fill="black" />
        </svg> Go Back
      </a>
    </span>
    <app-industry-report-action-component *ngIf="deviceType !== 'mobile'"></app-industry-report-action-component>
  </div>
  <div class="middle-wrapper">
    <app-company-sample-report-detials-page>
    </app-company-sample-report-detials-page>
  </div>
  <div class="right-sidebar-wrapper" *ngIf="deviceType !== 'mobile'">
    <app-industry-report-competitor-page></app-industry-report-competitor-page>
  </div>
</main>
